import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

import { ErrorBoundary } from '@/shared/ui/ErrorBoundary';

import { MobileSidebar } from './MobileSidebar';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export function AppShell(): ReactElement {
  return (
    <div className="relative flex min-h-screen bg-background">
      {/* Subtle ambient gradient — adds depth without distraction */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-[420px] bg-gradient-mesh opacity-40"
      />

      <Sidebar />
      <MobileSidebar />

      <div className="relative z-10 flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 px-4 py-6 md:px-8 md:py-8">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
